import React from 'react';

interface LogoProps {
    size?: number;
}

export const Logo: React.FC<LogoProps> = ({ size = 32 }) => (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none">
        <rect width="32" height="32" rx="8" fill="#2563EB"/>
        <path d="M8 12h16v2H8v-2zm0 4h12v2H8v-2zm0 4h16v2H8v-2z" fill="white"/>
        <circle cx="20" cy="8" r="3" fill="#10B981"/>
    </svg>
);
